const dashboard = {
    page_title: 'Bảng điều khiển',
    title: 'Bảng điều khiển',
    description: 'Xem tổng quan hiệu suất ứng dụng của bạn',
    total_users: 'Tổng số người dùng',
    total_users_tip: 'Tổng số người dùng',
    new_users_today: 'Người dùng mới hôm nay',
    new_users_today_tip: 'Số người dùng mới đăng ký trên ứng dụng của bạn hôm nay',
    new_users_7_days: 'Người dùng mới 7 ngày qua',
    new_users_7_days_tip: 'Số người dùng mới đăng ký trên ứng dụng của bạn trong 7 ngày qua',
    daily_active_users: 'Người dùng hoạt động theo ngày',
    daily_active_users_tip: 'Số người dùng duy nhất đã trao đổi token trên ứng dụng của bạn hôm nay',
    weekly_active_users: 'Người dùng hoạt động theo tuần',
    weekly_active_users_tip: 'Số người dùng duy nhất đã trao đổi token trên ứng dụng của bạn trong 7 ngày qua',
    monthly_active_users: 'Người dùng hoạt động theo tháng',
    monthly_active_users_tip: 'Số người dùng duy nhất đã trao đổi token trên ứng dụng của bạn trong 30 ngày qua',
};
export default Object.freeze(dashboard);
